onReady(($) => {
    $('.content-cards')
        .each((index, module) => {
            let $module = $(module)
            const $articles = $('.articles', $module)
            if ($articles.hasClass('one-upcoming-event') || $articles.hasClass('two-upcoming-events')) {
                return;
            }
            ;
            $('.articles', $module)
                .slick({
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true,
                    dots: true,
                    prevArrow: $(".slick-prev", $module),
                    nextArrow: $(".slick-next", $module),
                    fade: false,
                    responsive: [
                        {
                            breakpoint: 841,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 564,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            $module.hover(function () {
                $('.slick-next, .slick-prev', $module)
                    .toggleClass("chevron-visible");
            });
        });
    const contentCards = Array.from(document.querySelectorAll('.content-cards'))
    for (const contentCard of contentCards) {
        const ctaButton = contentCard.querySelector('.cta-button');
        ctaButton && ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, ctaButton, contentCard));
    }
});
